var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmokeIcon04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 219 127.6",
    style: {
      enableBackground: "new 0 0 219 127.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6A8BE5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Smoke-icon_4_",
    transform: "translate(-62.953 -258.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Path_3066_4_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.1,377.3h-98.3c-2.1,0-3.9-1.8-3.9-3.9v-17.2c0-2.2,1.7-3.9,3.9-3.9h98.3c2.1,0,3.9,1.8,3.9,3.9v17.2 C282,375.5,280.2,377.3,278.1,377.3z M179.8,355.3c-0.4,0-0.9,0.3-0.9,0.9v17.2c0,0.5,0.4,0.9,0.9,0.9h98.3c0.5,0,0.9-0.4,0.9-0.9 v-17.2c0-0.5-0.4-0.9-0.9-0.9H179.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Path_3067_4_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.7,335.2c-0.5,0-0.9-0.2-1.2-0.6c-0.5-0.6-0.4-1.5,0.2-2c0.1-0.1,10.3-10,12-22.9c0.7-5.5-1-9-2.9-12.8 c-2.6-5.1-5.2-10.3-1.8-20.1c6.1-17.7,23.7-12.2,23.9-12.1c0.7,0.2,1.1,0.9,1,1.6s-0.7,1.3-1.4,1.3c-6.5,0.3-12.1,4.7-13.9,11.1 c-1.6,5.4,0,8.4,2,12.2c2.2,4.2,4.7,9,3.2,17.7c-2.9,16.4-19.5,25.9-20.2,26.3C166.2,335.1,166,335.2,165.7,335.2z M187.3,266.9 c-4.5,0.6-9.8,3-12.5,10.9c-3,8.6-0.7,13.1,1.6,17.8c2,4,4.1,8.1,3.2,14.5c-0.8,5.7-3,10.8-5.4,14.9c4.1-4.1,8.2-9.9,9.4-16.9 c1.3-7.7-0.8-11.8-2.9-15.8c-2-3.9-4.1-7.9-2.2-14.5C180,273.1,183.2,269.2,187.3,266.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Path_3068_4_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.2,366.2c-0.5,0-0.9-0.2-1.2-0.6c-0.1-0.2-12.5-16.9,1.2-27.8c15-11.9,20.6-26,20.6-26.2 c0.3-0.7,1-1.1,1.7-0.9c0.7,0.2,1.2,0.8,1.2,1.5c0,0.8-1.1,18.9-14.7,30.1c0,0,0,0,0,0c-9.8,7.9-7.3,21.9-7.3,22.1 c0.1,0.7-0.2,1.4-0.9,1.6C169.6,366.2,169.4,366.2,169.2,366.2z M187.8,321.8c-3.4,5.3-8.8,12.1-16.7,18.4 c-4.8,3.8-6.3,8.9-4.7,15.1c0.3,1.1,0.7,2.2,1.1,3.1c0.3-5.4,2-12.9,8.7-18.3C182.5,334.7,186,327.5,187.8,321.8z M177,341.2 L177,341.2L177,341.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Path_3069_4_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240.7,377.8c-0.8,0-1.5-0.7-1.5-1.5l-0.2-18.9c0-0.8,0.7-1.5,1.5-1.5c0.9,0,1.5,0.7,1.5,1.5l0.2,18.9 C242.2,377.1,241.5,377.8,240.7,377.8C240.7,377.8,240.7,377.8,240.7,377.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmokeIcon04);
export default __webpack_public_path__ + "static/media/smoke-icon-04.219ba306.svg";
export { ForwardRef as ReactComponent };